import { Box, IconButton, Typography, useTheme, Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField, MenuItem, Grid, Avatar, Input } from "@mui/material";
import { useEffect, useState } from "react";
import { DataGrid, GridToolbarQuickFilter } from "@mui/x-data-grid";
import { useAuth } from "../../../AuthContext";
import { tokens } from "../../../theme";
import HeaderPage from "../../../components/Header";
import { ToastContainer, toast } from 'react-toastify';
import AdminPanelSettingsOutlinedIcon from '@mui/icons-material/AdminPanelSettingsOutlined';
import SecurityOutlinedIcon from '@mui/icons-material/SecurityOutlined';
import LockOpenOutlinedIcon from '@mui/icons-material/LockOpenOutlined';
import AirplanemodeActiveOutlinedIcon from '@mui/icons-material/AirplanemodeActiveOutlined';
import AirplanemodeInactiveOutlinedIcon from '@mui/icons-material/AirplanemodeInactiveOutlined';
import DeleteForeverOutlinedIcon from '@mui/icons-material/DeleteForeverOutlined';
import EditNoteOutlinedIcon from '@mui/icons-material/EditNoteOutlined';
import AddCircleOutlineOutlinedIcon from '@mui/icons-material/AddCircleOutlineOutlined';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import DownloadIcon from '@mui/icons-material/Download';

const Team = () => {
    const [teams, setTeams] = useState([]);
    const [loading, setLoading] = useState(true);
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const { getData, addData, updateData, deleteData } = useAuth();
    const [openDialog, setOpenDialog] = useState(false);
    const [viewOpen, setViewOpen] = useState(false);
    const [isEditing, setIsEditing] = useState(false);
    const [selectedStaffId, setSelectedStaffId] = useState(null);
    const [selectedUser, setSelectedUser] = useState(null);
    const [imageFile, setImageFile] = useState(null);
    const [imagePreview, setImagePreview] = useState(null);
    const [formData, setFormData] = useState({
        FirstName: "",
        LastName: "",
        email: "",
        Password: "",
        Cell: "",
        employeeType: "permanent",
        department: "",
        physicalAddress: [{street: '', city: '', town: '', country: '',}],
        postalAddress: [{code: '',city: '',town: '',country: '',}],
        date_of_birth: [{ day: '', month: '',year: '', }],
        nationality: "",
        national_id: "",
        next_of_kin: [{fullname: '',email: '',cell: '',}],
        role: "user",
        role_explanation: "",
        drive_quote: "",
        passion: "",
        knowledge: "",
        core_values: "",
        focus: "",
        leaveCredit: 24,
        usedUpCredit: 0,
        leftCredit: 24,
        status: "active",
        isVerified: "0",
        isLogedIn: "0",
        email_verified: "0",
        verified_at: "",
        image: null
    });

    useEffect(() => {
        async function fetchData() {
            try {
                const response = await getData("proccess.php", "staffs");
                if (response.success) {
                    setTeams(response.data);
                } else {
                    toast.error(response.message || "Failed to load team data");
                }
            } catch (err) {
                toast.error("Network error: Failed to fetch teams");
                console.error("Fetch error:", err);
            } finally {
                setLoading(false);
            }
        }
        fetchData();
    }, [getData]);

    // Export to Excel function
    const exportToExcel = () => {
        if (teams.length === 0) {
            toast.warning("No data to export");
            return;
        }

        try {
            // Create CSV content
            const headers = [
                'ID',
                'First Name',
                'Last Name',
                'Email',
                'Cell',
                'Employee Type',
                'Department',
                'Nationality',
                'National ID',
                'Next of Kin',
                'Date of Birth',
                'Role',
                'Account Status',
                'Verified',
                'Last Login',
                'Registration Date',
                'Physical Address',
                'Postal Address',
                'Role Explanation',
                'Drive Quote',
                'Passion',
                'Knowledge',
                'Core Values',
                'Focus',
                'leaveCredit',
                'usedUpCredit',
                'leftCredit'
            ];

            const csvContent = teams.map(staff => {
                // Parse complex fields
                let parsedDob = staff.date_of_birth;
                if (typeof staff.date_of_birth === 'string') {
                    try {
                        parsedDob = JSON.parse(staff.date_of_birth);
                    } catch (e) {
                        parsedDob = null;
                    }
                }

                let parsedNok = staff.next_of_kin;
                if (typeof staff.next_of_kin === 'string') {
                    try {
                        parsedNok = JSON.parse(staff.next_of_kin);
                    } catch (e) {
                        parsedNok = null;
                    }
                }

                let parsedPhysical = staff.physicalAddress;
                if (typeof staff.physicalAddress === 'string') {
                    try {
                        parsedPhysical = JSON.parse(staff.physicalAddress);
                    } catch (e) {
                        parsedPhysical = null;
                    }
                }

                let parsedPostal = staff.postalAddress;
                if (typeof staff.postalAddress === 'string') {
                    try {
                        parsedPostal = JSON.parse(staff.postalAddress);
                    } catch (e) {
                        parsedPostal = null;
                    }
                }

                const dobText = parsedDob?.[0] ? `${parsedDob[0].day}/${parsedDob[0].month}/${parsedDob[0].year}` : 'N/A';
                const nokText = parsedNok?.[0]?.fullname || 'N/A';
                const physicalAddressText = parsedPhysical?.[0] ? 
                    `${parsedPhysical[0].street}, ${parsedPhysical[0].city}, ${parsedPhysical[0].town}, ${parsedPhysical[0].country}` : 'N/A';
                const postalAddressText = parsedPostal?.[0] ? 
                    `${parsedPostal[0].code}, ${parsedPostal[0].city}, ${parsedPostal[0].town}, ${parsedPostal[0].country}` : 'N/A';

                return [
                    staff.Id,
                    `"${staff.FirstName || ''}"`,
                    `"${staff.LastName || ''}"`,
                    `"${staff.email || ''}"`,
                    `"${staff.Cell || ''}"`,
                    `"${staff.employeeType || ''}"`,
                    `"${staff.department || ''}"`,
                    `"${staff.nationality || ''}"`,
                    `"${staff.national_id || ''}"`,
                    `"${nokText}"`,
                    `"${dobText}"`,
                    `"${staff.role || ''}"`,
                    `"${staff.status || ''}"`,
                    `"${staff.isVerified === "1" ? 'Verified' : 'Not Verified'}"`,
                    `"${staff.last_login || ''}"`,
                    `"${staff.createDate || ''}"`,
                    `"${physicalAddressText}"`,
                    `"${postalAddressText}"`,
                    `"${staff.role_explanation || ''}"`,
                    `"${staff.drive_quote || ''}"`,
                    `"${staff.passion || ''}"`,
                    `"${staff.knowledge || ''}"`,
                    `"${staff.core_values || ''}"`,
                    `"${staff.focus || ''}"`,
                    `"${staff.leaveCredit || ''}"`,
                    `"${staff.usedUpCredit || ''}"`,
                    `"${staff.leftCredit || ''}"`,
                ].join(',');
            });

            // Combine headers and data
            const csv = [headers.join(','), ...csvContent].join('\n');

            // Create and download file
            const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
            const link = document.createElement('a');
            const url = URL.createObjectURL(blob);
            link.setAttribute('href', url);
            link.setAttribute('download', `team_members_${new Date().toISOString().split('T')[0]}.csv`);
            link.style.visibility = 'hidden';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            
            toast.success("Team data exported successfully");
        } catch (error) {
            console.error('Export error:', error);
            toast.error("Failed to export data");
        }
    };

    const handleOpenDialog = (isEdit = false, staff = null) => {
        setIsEditing(isEdit);
        setSelectedStaffId(isEdit ? staff.Id : null);
        let physicalAddress = [{street: '', city: '', town: '', country: '',}];
        let postalAddress = [{code: '',city: '',town: '',country: '',}];
        let date_of_birth = [{ day: '', month: '',year: '', }];
        let next_of_kin = [{fullname: '',email: '',cell: '',}];
        if (isEdit) {
            if (staff.physicalAddress) {
                try {
                    const parsed = typeof staff.physicalAddress === 'string' ? JSON.parse(staff.physicalAddress) : staff.physicalAddress;
                    physicalAddress = Array.isArray(parsed) && parsed.length > 0 ? parsed : physicalAddress;
                } catch (e) {
                    physicalAddress = [{street: '', city: '', town: '', country: '',}];
                }
            }
            if (staff.postalAddress) {
                try {
                    const parsed = typeof staff.postalAddress === 'string' ? JSON.parse(staff.postalAddress) : staff.postalAddress;
                    postalAddress = Array.isArray(parsed) && parsed.length > 0 ? parsed : postalAddress;
                } catch (e) {
                    postalAddress = [{code: '',city: '',town: '',country: '',}];
                }
            }
            if (staff.date_of_birth) {
                try {
                    const parsed = typeof staff.date_of_birth === 'string' ? JSON.parse(staff.date_of_birth) : staff.date_of_birth;
                    date_of_birth = Array.isArray(parsed) && parsed.length > 0 ? parsed : date_of_birth;
                } catch (e) {
                    date_of_birth = [{ day: '', month: '',year: '', }];
                }
            }
            if (staff.next_of_kin) {
                try {
                    const parsed = typeof staff.next_of_kin === 'string' ? JSON.parse(staff.next_of_kin) : staff.next_of_kin;
                    next_of_kin = Array.isArray(parsed) && parsed.length > 0 ? parsed : next_of_kin;
                } catch (e) {
                    next_of_kin = [{fullname: '',email: '',cell: '',}];
                }
            }
        }
        setFormData(
            isEdit
                ? {
                      FirstName: staff.FirstName,
                      LastName: staff.LastName,
                      email: staff.email,
                      Password: "",
                      Cell: staff.Cell,
                        employeeType: staff.employeeType || "permanent",
                      department: staff.department || "",
                      physicalAddress,
                      postalAddress,
                      date_of_birth,
                      nationality: staff.nationality || "",
                      national_id: staff.national_id || "",
                      next_of_kin,
                      role: staff.role,
                      role_explanation: staff.role_explanation || "",
                      drive_quote: staff.drive_quote || "",
                      passion: staff.passion || "",
                      knowledge: staff.knowledge || "",
                      core_values: staff.core_values || "",
                      focus: staff.focus || "",
                        leaveCredit: staff.leaveCredit || 24,
                        usedUpCredit: staff.usedUpCredit || 0,
                        leftCredit: staff.leftCredit || 24,
                      status: staff.status,
                      isVerified: staff.isVerified,
                      isLogedIn: staff.isLogedIn || "0",
                      email_verified: staff.email_verified || "0",
                      verified_at: staff.verified_at || "",
                      image: staff.image || null
                  }
                : {
                      FirstName: "",
                      LastName: "",
                      email: "",
                      Password: "",
                      Cell: "",
                        employeeType: "permanent",
                      department: "",
                      physicalAddress,
                      postalAddress,
                      date_of_birth,
                      nationality: "",
                      national_id: "",
                      next_of_kin,
                      role: "user",
                      role_explanation: "",
                      drive_quote: "",
                      passion: "",
                      knowledge: "",
                      core_values: "",
                      focus: "",
                          leaveCredit: 24,
                            usedUpCredit: 0,
                            leftCredit: 24,
                      status: "active",
                      isVerified: "0",
                      isLogedIn: "0",
                      email_verified: "0",
                      verified_at: "",
                      image: null
                  }
        );
        if (isEdit) {
            setImagePreview(staff.image || null);
        } else {
            setImagePreview(null);
        }
        setImageFile(null);
        setOpenDialog(true);
    };

    const handleCloseDialog = () => {
        setOpenDialog(false);
        setImageFile(null);
        setImagePreview(null);
        setFormData({
            FirstName: "",
            LastName: "",
            email: "",
            Password: "",
            Cell: "",
            employeeType: "permanent",
            department: "",
            physicalAddress: [{street: '', city: '', town: '', country: '',}],
            postalAddress: [{code: '',city: '',town: '',country: '',}],
            date_of_birth: [{ day: '', month: '',year: '', }],
            nationality: "",
            national_id: "",
            next_of_kin: [{fullname: '',email: '',cell: '',}],
            role: "user",
            role_explanation: "",
            drive_quote: "",
            passion: "",
            knowledge: "",
            core_values: "",
            focus: "",
            leaveCredit: 24,
            usedUpCredit: 0,
            leftCredit: 24,
            status: "active",
            isVerified: "0",
            isLogedIn: "0",
            email_verified: "0",
            verified_at: "",
            image: null
        });
    };

    const handleViewClick = (staff) => {
        setSelectedUser(staff);
        setViewOpen(true);
    };

    const handleImageChange = (e) => {
        const file = e.target.files[0];
        setImageFile(file);
        if (file) {
            const reader = new FileReader();
            reader.onload = (e) => setImagePreview(e.target.result);
            reader.readAsDataURL(file);
        } else {
            setImagePreview(null);
        }
    }; 

    const handleFileChange = (e) => {
        setFormData(prev => ({
        ...prev,
        image: e.target.files[0]
        }));
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        if (name.startsWith('physical')) {
            const field = name.replace('physical', '').toLowerCase();
            setFormData(prev => ({
                ...prev,
                physicalAddress: [{ ...prev.physicalAddress[0], [field]: value }]
            }));
        } else if (name.startsWith('postal')) {
            let field = name.replace('postal', '').toLowerCase();
            if (field === 'code') field = 'code';
            setFormData(prev => ({
                ...prev,
                postalAddress: [{ ...prev.postalAddress[0], [field]: value }]
            }));
        } else if (name.startsWith('dob')) {
            const field = name.replace('dob', '').toLowerCase();
            setFormData(prev => ({
                ...prev,
                date_of_birth: [{ ...prev.date_of_birth[0], [field]: value }]
            }));
        } else if (name.startsWith('nextOfKin')) {
            let field = name.replace('nextOfKin', '').toLowerCase();
            if (field === 'fullname') field = 'fullname';
            else if (field === 'email') field = 'email';
            else if (field === 'cell') field = 'cell';
            setFormData(prev => ({
                ...prev,
                next_of_kin: [{ ...prev.next_of_kin[0], [field]: value }]
            }));
        } else {
            setFormData(prev => ({ ...prev, [name]: value }));
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            let payload = { ...formData };

            // Check and set to null if empty
            const paObj = payload.physicalAddress[0];
            if (paObj.street === '' && paObj.city === '' && paObj.town === '' && paObj.country === '') {
                payload.physicalAddress = null;
            }
            const postObj = payload.postalAddress[0];
            if (postObj.code === '' && postObj.city === '' && postObj.town === '' && postObj.country === '') {
                payload.postalAddress = null;
            }
            const dobObj = payload.date_of_birth[0];
            if (dobObj.day === '' && dobObj.month === '' && dobObj.year === '') {
                payload.date_of_birth = null;
            }
            const nokObj = payload.next_of_kin[0];
            if (nokObj.fullname === '' && nokObj.email === '' && nokObj.cell === '') {
                payload.next_of_kin = null;
            }

            // Stringify JSON fields
            if (payload.physicalAddress) {
                payload.physicalAddress = JSON.stringify(payload.physicalAddress);
            }
            if (payload.postalAddress) {
                payload.postalAddress = JSON.stringify(payload.postalAddress);
            }
            if (payload.date_of_birth) {
                payload.date_of_birth = JSON.stringify(payload.date_of_birth);
            }
            if (payload.next_of_kin) {
                payload.next_of_kin = JSON.stringify(payload.next_of_kin);
            }

            // Handle image for updates: remove old image if no new file
            

            let dataToSend;
            const hasFile = !!imageFile;
            if (hasFile) {
                dataToSend = payload;
            } else {
                dataToSend = payload;
            }

            if (!isEditing) {
                const response = await addData("proccess.php", "staffs", dataToSend);
                if (response.success) {
                    toast.success("Staff created successfully");
                    setTeams(response.data || [...teams, response.data]);
                } else {
                    toast.error(response.message || "Failed to create staff");
                }
            } else {
                
                const response = await updateData("proccess.php", "staffs", dataToSend, selectedStaffId);
                
                if (response.success) {
                    toast.success("Staff updated successfully");
                    setTeams(response.data || teams.map(staff => staff.Id === selectedStaffId ? { ...staff, ...payload } : staff));
                } else {
                    toast.error(response.message || "Failed to update staff");
                }
            }
            handleCloseDialog();
        } catch (err) {
            toast.error("Network error: Failed to save staff");
            console.error("Save error:", err);
        }
    };

    const handleDeleteClick = async (id) => {
        if (window.confirm("Are you sure you want to delete this staff member?")) {
            try {
                const response = await deleteData("proccess.php", "staffs", id);
                if (response.success) {
                    toast.success("Staff deleted successfully");
                    setTeams((prev) => prev.filter((staff) => staff.Id !== id));
                } else {
                    toast.error(response.message || "Failed to delete staff");
                }
            } catch (err) {
                toast.error("Network error: Failed to delete staff");
                console.error("Delete error:", err);
            }
        }
    };

    const handleVerifyToggle = async (id, currentStatus) => {
        const newStatus = currentStatus === "1" ? "0" : "1";
        try {
            const response = await updateData("proccess.php", "staffs", { isVerified: newStatus }, id);
            if (response.success) {
                toast.success(`Staff ${newStatus === "1" ? "verified" : "unverified"} successfully`);
                setTeams(response.data || teams.map(staff => staff.Id === id ? { ...staff, isVerified: newStatus } : staff));
            } else {
                toast.error(response.message || "Failed to update verification status");
            }
        } catch (err) {
            toast.error("Network error: Failed to update verification status");
            console.error("Verify toggle error:", err);
        }
    };

    const columns = [
        { field: "Id", headerName: "ID", flex: 0.5, minWidth: 20 },
        {
            field: "image",
            headerName: "Photo",
            width: 80,
            renderCell: ({ row: { image } }) => (
                <Avatar src={`https://mindsinaction.com.na/assets/media/pictures/${image}`} sx={{ width: 30, height: 30, marginTop: '.8rem' }} />
            ),
        },
        { field: "FirstName", headerName: "First Name", cellClassName: "name-column--cell", flex: 1, minWidth: 120 },
        { field: "LastName", headerName: "Last Name", flex: 1, minWidth: 120 },
        { field: "email", headerName: "Email", flex: 1, minWidth: 120 },
        { field: "Cell", headerName: "Cell", flex: 1, minWidth: 120 },
        { field: "employeeType", headerName: "Employee Type", flex: 1, minWidth: 120 },
        { field: "department", headerName: "Department", flex: 1, minWidth: 120 },
        { field: "nationality", headerName: "Nationality", flex: 1, minWidth: 100 },
        {
            field: "next_of_kin",
            headerName: "Next of Kin",
            flex: 1,
            minWidth: 120,
            renderCell: ({ row: { next_of_kin } }) => {
                let parsedNok = next_of_kin;
                if (typeof next_of_kin === 'string') {
                    try {
                        parsedNok = JSON.parse(next_of_kin);
                    } catch (e) {
                        parsedNok = null;
                    }
                }
                return parsedNok?.[0]?.fullname || 'N/A';
            },
        },
        { field: "createDate", headerName: "Registration Date", flex: 1, minWidth: 120 },
        {
            field: "date_of_birth",
            headerName: "Date of Birth",
            flex: 1,
            minWidth: 120,
            renderCell: ({ row: { date_of_birth } }) => {
                let parsedDob = date_of_birth;
                if (typeof date_of_birth === 'string') {
                    try {
                        parsedDob = JSON.parse(date_of_birth);
                    } catch (e) {
                        parsedDob = null;
                    }
                }
                return (
                    <Typography>
                        {parsedDob?.[0] ? `${parsedDob[0].day}/${parsedDob[0].month}/${parsedDob[0].year}` : 'N/A'}
                    </Typography>
                );
            },
        },
        {
            field: "role",
            headerName: "Role",
            flex: 1,
            minWidth: 100,
            renderCell: ({ row: { role } }) => (
                <Box
                    width="60%"
                    m="10px 0 0 0"
                    p="5px"
                    display="flex"
                    justifyContent="start"
                    alignItems="center"
                    color={role === "admin" ? colors.teal[400] : colors.blue[200]}
                    borderRadius="5px"
                >
                    {role === "admin" && <AdminPanelSettingsOutlinedIcon />}
                    {role === "manager" && <SecurityOutlinedIcon />}
                    {role === "user" && <LockOpenOutlinedIcon />}
                    <Typography sx={{ ml: "5px" }}>{role}</Typography>
                </Box>
            ),
        },
        { field: "leaveCredit", headerName: "Leave Credit", flex: 1, minWidth: 120 },
        { field: "usedUpCredit", headerName: "Used Up Credit", flex: 1, minWidth: 120 },
        { field: "leftCredit", headerName: "Left Credit", flex: 1, minWidth: 120 },
        { field: "status", headerName: "Account Status", flex: 1, minWidth: 120 },
        {
            field: "isVerified",
            headerName: "Verified",
            flex: 1,
            minWidth: 120,
            renderCell: ({ row: { isVerified, Id } }) => (
                <Box display="flex" alignItems="center" justifyContent="start">
                    {isVerified === "1" ? (
                        <Box display="flex" alignItems="center" justifyContent="start" mt=".5rem">
                            <IconButton sx={{ color: "red" }} onClick={() => handleVerifyToggle(Id, isVerified)}>
                                <AirplanemodeInactiveOutlinedIcon />
                            </IconButton>
                            <Typography sx={{ color: "red" }}>Unverify(1)</Typography>
                        </Box>
                    ) : (
                        <Box display="flex" alignItems="center" justifyContent="start" mt=".5rem">
                            <IconButton sx={{ color: "green" }} onClick={() => handleVerifyToggle(Id, isVerified)}>
                                <AirplanemodeActiveOutlinedIcon />
                            </IconButton>
                            <Typography sx={{ color: "green" }}>Verify(0)</Typography>
                        </Box>
                    )}
                </Box>
            ),
        },
        { field: "last_login", headerName: "Last Login", flex: 1, minWidth: 120 },
        {
            field: "actions",
            headerName: "Action",
            flex: 1,
            minWidth: 120,
            renderCell: ({ row: { Id } }) => (
                <Box>
                    <IconButton
                        sx={{ color: colors.blue[400] }}
                        href={`/admin/dashboard/staff/${teams.find((staff) => staff.Id === Id).Id}`}
                    >
                        <VisibilityOutlinedIcon />
                    </IconButton>
                    <IconButton
                        sx={{ color: colors.dark[400] }}
                        onClick={() => handleOpenDialog(true, teams.find((staff) => staff.Id === Id))}
                    >
                        <EditNoteOutlinedIcon />
                    </IconButton>
                    <IconButton
                        sx={{ color: colors.orange[400] }}
                        onClick={() => handleDeleteClick(Id)}
                    >
                        <DeleteForeverOutlinedIcon />
                    </IconButton>
                </Box>
            ),
        },
    ];

    return (
        <Box m="10px" sx={{ overflow: 'hidden' }}>
            <ToastContainer
                position="top-right"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />
            <HeaderPage title="OUR TEAM" subTitle="Managing the team members" />
            
            <Box display="flex" justifyContent="flex-end" mb={2} gap={2}>
                <Button
                    variant="outlined"
                    startIcon={<DownloadIcon />}
                    onClick={exportToExcel}
                    sx={{
                        borderColor: colors.green[400],
                        color: colors.green[400],
                        '&:hover': {
                            backgroundColor: colors.green[50],
                            borderColor: colors.green[500],
                        }
                    }}
                >
                    Export Excel
                </Button>
                <Button
                    variant="contained"
                    color="primary"
                    startIcon={<AddCircleOutlineOutlinedIcon />}
                    onClick={() => handleOpenDialog(false)}
                >
                    Add Staff
                </Button>
            </Box>
            <Box
                sx={{
                    height: 'calc(100vh - 200px)',
                    width: '100%',
                    overflow: 'hidden',
                }}
                backgroundColor={colors.dark[300]}
                padding=".2rem"
            >
                <DataGrid
                    rows={teams}
                    columns={columns}
                    getRowId={(row) => row.Id}
                    loading={loading}
                    sx={{
                        border: "none",
                        ".MuiDataGrid-cell": {
                            borderBottom: "none",
                            backgroundColor: "none",
                        },
                        ".MuiDataGrid-toolbarContainer": {
                            padding: "10px",
                            backgroundColor: colors.primary[400],
                            borderBottom: "none",
                        },
                        ".MuiDataGrid-quickFilter": {
                            padding: "8px",
                            borderRadius: "4px",
                            border: `1px solid ${colors.primary[100]}`,
                        },
                    }}
                    slots={{
                        toolbar: () => (
                            <div>
                                <GridToolbarQuickFilter />
                            </div>
                        ),
                    }}
                    slotProps={{
                        toolbar: {
                            showQuickFilter: true,
                            quickFilterProps: {
                                debounceMs: 500,
                                placeholder: "Search...",
                            },
                        },
                    }}
                />
            </Box>

            <Dialog open={openDialog} onClose={handleCloseDialog} maxWidth="md" fullWidth>
                <DialogTitle>{isEditing ? "Edit Staff" : "Add New Staff"}</DialogTitle>
                <DialogContent>
                    <Box component="form" onSubmit={handleSubmit} sx={{ mt: 2 }}>
                        <TextField
                            fullWidth
                            margin="normal"
                            label="First Name"
                            name="FirstName"
                            value={formData.FirstName}
                            onChange={handleInputChange}
                            required
                        />
                        <TextField
                            fullWidth
                            margin="normal"
                            label="Last Name"
                            name="LastName"
                            value={formData.LastName}
                            onChange={handleInputChange}
                            required
                        />
                        <TextField
                            fullWidth
                            margin="normal"
                            label="Email"
                            name="email"
                            type="email"
                            value={formData.email}
                            onChange={handleInputChange}
                            required
                        />
                        <TextField
                            fullWidth
                            margin="normal"
                            label="Password"
                            name="Password"
                            type="password"
                            value={formData.Password}
                            onChange={handleInputChange}
                            required={!isEditing}
                        />
                        <TextField
                            fullWidth
                            margin="normal"
                            label="Cell(081XXXXXXX)"
                            name="Cell"
                            value={formData.Cell}
                            onChange={handleInputChange}
                            type="number"
                            inputProps={{ min: 7, max: 10 }}
                        />
                        <TextField
                            select
                            fullWidth
                            margin="normal"
                            label="Employee Type"
                            name="employeeType"
                            value={formData.employeeType}
                            onChange={handleInputChange}
                        >
                            <MenuItem value="">Select Employee Type</MenuItem>
                            <MenuItem value="permanent">Permanent</MenuItem>
                            <MenuItem value="temporary">Temporary</MenuItem>
                            <MenuItem value="contractor">Contract</MenuItem>
                            <MenuItem value="founder">Founder</MenuItem>
                            <MenuItem value="intern">Internship</MenuItem>
                        </TextField>
                        <Box display="flex" gap={2}>
                            <TextField
                                fullWidth
                                margin="normal"
                                label="Leave Credit"
                                name="leaveCredit"
                                value={formData.leaveCredit}
                                onChange={handleInputChange}
                                type="number"
                                inputProps={{ min: 0 }}
                            />
                            <TextField
                                fullWidth
                                margin="normal"
                                label="Used Up Credit"
                                name="usedUpCredit"
                                value={formData.usedUpCredit}
                                onChange={handleInputChange}
                                type="number"
                                inputProps={{ min: 0 }}
                            />
                            <TextField
                                fullWidth
                                margin="normal"
                                label="Left Credit"
                                name="leftCredit"
                                value={formData.leftCredit}
                                onChange={handleInputChange}
                                type="number"
                                inputProps={{ min: 0 }}
                            />
                        </Box>
                        <TextField
                            fullWidth
                            margin="normal"
                            label="Department"
                            name="department"
                            value={formData.department}
                            onChange={handleInputChange}
                        />
                        <TextField
                            fullWidth
                            margin="normal"
                            label="Nationality"
                            name="nationality"
                            value={formData.nationality}
                            onChange={handleInputChange}
                        />
                        <TextField
                            fullWidth
                            margin="normal"
                            label="National ID"
                            name="national_id"
                            value={formData.national_id}
                            onChange={handleInputChange}
                        />
                        <TextField
                            fullWidth
                            margin="normal"
                            label="Next of Kin Fullname"
                            name="nextOfKinFullname"
                            value={formData.next_of_kin[0].fullname}
                            onChange={handleInputChange}
                        />
                        <TextField
                            fullWidth
                            margin="normal"
                            label="Next of Kin Email"
                            name="nextOfKinEmail"
                            type="email"
                            value={formData.next_of_kin[0].email}
                            onChange={handleInputChange}
                        />
                        <TextField
                            fullWidth
                            margin="normal"
                            label="Next of Kin Cell"
                            name="nextOfKinCell"
                            value={formData.next_of_kin[0].cell}
                            onChange={handleInputChange}
                        />
                        <Box display="flex" gap={2}>
                            <TextField
                                fullWidth
                                margin="normal"
                                label="Day"
                                name="dobDay"
                                value={formData.date_of_birth[0].day}
                                onChange={handleInputChange}
                                type="number"
                                inputProps={{ min: 1, max: 31 }}
                            />
                            <TextField
                                fullWidth
                                margin="normal"
                                label="Month"
                                name="dobMonth"
                                value={formData.date_of_birth[0].month}
                                onChange={handleInputChange}
                                type="number"
                                inputProps={{ min: 1, max: 12 }}
                            />
                            <TextField
                                fullWidth
                                margin="normal"
                                label="Year"
                                name="dobYear"
                                value={formData.date_of_birth[0].year}
                                onChange={handleInputChange}
                                type="number"
                                inputProps={{ min: 1900, max: 2025 }}
                            />
                        </Box>
                        <TextField
                            fullWidth
                            margin="normal"
                            label="Physical Street"
                            name="physicalStreet"
                            value={formData.physicalAddress[0].street}
                            onChange={handleInputChange}
                        />
                        <TextField
                            fullWidth
                            margin="normal"
                            label="Physical City"
                            name="physicalCity"
                            value={formData.physicalAddress[0].city}
                            onChange={handleInputChange}
                        />
                        <TextField
                            fullWidth
                            margin="normal"
                            label="Physical Town"
                            name="physicalTown"
                            value={formData.physicalAddress[0].town}
                            onChange={handleInputChange}
                        />
                        <TextField
                            fullWidth
                            margin="normal"
                            label="Physical Country"
                            name="physicalCountry"
                            value={formData.physicalAddress[0].country}
                            onChange={handleInputChange}
                        />
                        <TextField
                            fullWidth
                            margin="normal"
                            label="Postal Code"
                            name="postalCode"
                            value={formData.postalAddress[0].code}
                            onChange={handleInputChange}
                        />
                        <TextField
                            fullWidth
                            margin="normal"
                            label="Postal City"
                            name="postalCity"
                            value={formData.postalAddress[0].city}
                            onChange={handleInputChange}
                        />
                        <TextField
                            fullWidth
                            margin="normal"
                            label="Postal Town"
                            name="postalTown"
                            value={formData.postalAddress[0].town}
                            onChange={handleInputChange}
                        />
                        <TextField
                            fullWidth
                            margin="normal"
                            label="Postal Country"
                            name="postalCountry"
                            value={formData.postalAddress[0].country}
                            onChange={handleInputChange}
                        />
                        <Box sx={{ mt: 2 }}>
                            <Typography>Profile Image (optional)</Typography>
                            {imagePreview && (
                                <img
                                    src={imagePreview}
                                    alt="Preview"
                                    style={{ maxWidth: '200px', maxHeight: '200px', marginTop: '10px' }}
                                />
                            )}
                            <Input 
                                type="file" 
                                style={{width: "100%"}} 
                                id="image" 
                                name="image"
                                onChange={handleFileChange}
                                inputProps={{ accept: 'image/*' }}
                            />
                        </Box>
                        <TextField
                            select
                            fullWidth
                            margin="normal"
                            label="Role"
                            name="role"
                            value={formData.role}
                            onChange={handleInputChange}
                            required
                        >
                            <MenuItem value="admin">Admin</MenuItem>
                            <MenuItem value="hr">Hr</MenuItem>
                            <MenuItem value="manager">Manager</MenuItem>
                            <MenuItem value="supervisor">Supervisor</MenuItem>
                            <MenuItem value="user">User</MenuItem>
                        </TextField>
                        <TextField
                            fullWidth
                            margin="normal"
                            label="Role Explanation"
                            name="role_explanation"
                            value={formData.role_explanation}
                            onChange={handleInputChange}
                            multiline
                            rows={2}
                        />
                        <TextField
                            fullWidth
                            margin="normal"
                            label="Drive Quote"
                            name="drive_quote"
                            value={formData.drive_quote}
                            onChange={handleInputChange}
                            multiline
                            rows={2}
                        />
                        <TextField
                            fullWidth
                            margin="normal"
                            label="Passion"
                            name="passion"
                            value={formData.passion}
                            onChange={handleInputChange}
                            multiline
                            rows={2}
                        />
                        <TextField
                            fullWidth
                            margin="normal"
                            label="Knowledge"
                            name="knowledge"
                            value={formData.knowledge}
                            onChange={handleInputChange}
                            multiline
                            rows={2}
                        />
                        <TextField
                            fullWidth
                            margin="normal"
                            label="Core Values"
                            name="core_values"
                            value={formData.core_values}
                            onChange={handleInputChange}
                            multiline
                            rows={2}
                        />
                        <TextField
                            fullWidth
                            margin="normal"
                            label="Focus"
                            name="focus"
                            value={formData.focus}
                            onChange={handleInputChange}
                            multiline
                            rows={2}
                        />
                        <TextField
                            select
                            fullWidth
                            margin="normal"
                            label="Status"
                            name="status"
                            value={formData.status}
                            onChange={handleInputChange}
                            required
                        >
                            <MenuItem value="active">Active</MenuItem>
                            <MenuItem value="inactive">Inactive</MenuItem>
                        </TextField>
                        <TextField
                            select
                            fullWidth
                            margin="normal"
                            label="Verified"
                            name="isVerified"
                            value={formData.isVerified}
                            onChange={handleInputChange}
                            required
                        >
                            <MenuItem value="0">Not Verified</MenuItem>
                            <MenuItem value="1">Verified</MenuItem>
                        </TextField>
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCloseDialog}>Cancel</Button>
                    <Button type="submit" variant="contained" color="primary" onClick={handleSubmit}>
                        {isEditing ? "Update" : "Create"}
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog open={viewOpen} onClose={() => setViewOpen(false)} maxWidth="lg" fullWidth>
                <DialogTitle>Staff Details</DialogTitle>
                <DialogContent>
                    {selectedUser && (() => {
                        // Parse complex fields if they are strings
                        let parsedPhysical = selectedUser.physicalAddress;
                        if (typeof parsedPhysical === 'string') {
                            try {
                                parsedPhysical = JSON.parse(parsedPhysical);
                            } catch (e) {
                                parsedPhysical = null;
                            }
                        }
                        let parsedPostal = selectedUser.postalAddress;
                        if (typeof parsedPostal === 'string') {
                            try {
                                parsedPostal = JSON.parse(parsedPostal);
                            } catch (e) {
                                parsedPostal = null;
                            }
                        }
                        let parsedDob = selectedUser.date_of_birth;
                        if (typeof parsedDob === 'string') {
                            try {
                                parsedDob = JSON.parse(parsedDob);
                            } catch (e) {
                                parsedDob = null;
                            }
                        }
                        let parsedNok = selectedUser.next_of_kin;
                        if (typeof parsedNok === 'string') {
                            try {
                                parsedNok = JSON.parse(parsedNok);
                            } catch (e) {
                                parsedNok = null;
                            }
                        }

                        return (
                            <Box>
                                {selectedUser.image && (
                                    <Box mb={2} display="flex" justifyContent="center">
                                        <img
                                            src={`https://mindsinaction.com.na/assets/media/pictures/${selectedUser.image}`}
                                            alt="Profile"
                                            style={{ width: '150px', height: '150px', borderRadius: '50%' }}
                                        />
                                    </Box>
                                )}
                                <Grid container spacing={2}>
                                    <Grid item xs={6}>
                                        <Typography><strong>First Name:</strong> {selectedUser.FirstName}</Typography>
                                        <Typography><strong>Last Name:</strong> {selectedUser.LastName}</Typography>
                                        <Typography><strong>Email:</strong> {selectedUser.email}</Typography>
                                        <Typography><strong>Cell:</strong> {selectedUser.Cell}</Typography>
                                        <Typography><strong>Department:</strong> {selectedUser.department || 'N/A'}</Typography>
                                        <Typography><strong>Nationality:</strong> {selectedUser.nationality || 'N/A'}</Typography>
                                        <Typography><strong>National ID:</strong> {selectedUser.national_id || 'N/A'}</Typography>
                                        <Typography><strong>Role:</strong> {selectedUser.role}</Typography>
                                        <Typography><strong>Status:</strong> {selectedUser.status}</Typography>
                                        <Typography><strong>Verified:</strong> {selectedUser.isVerified === "1" ? "Yes" : "No"}</Typography>
                                        <Typography><strong>Logged In:</strong> {selectedUser.isLogedIn === "1" ? "Yes" : "No"}</Typography>
                                        <Typography><strong>Registration Date:</strong> {selectedUser.createDate || 'N/A'}</Typography>
                                        <Typography><strong>Last Login:</strong> {selectedUser.last_login || 'N/A'}</Typography>
                                    </Grid>
                                    <Grid item xs={6}>
                                        <Typography><strong>Date of Birth:</strong> {parsedDob?.[0] ? `${parsedDob[0].day}/${parsedDob[0].month}/${parsedDob[0].year}` : 'N/A'}</Typography>
                                        <Typography variant="subtitle1"><strong>Physical Address:</strong></Typography>
                                        <Typography>Street: {parsedPhysical?.[0]?.street || ''}</Typography>
                                        <Typography>City: {parsedPhysical?.[0]?.city || ''}</Typography>
                                        <Typography>Town: {parsedPhysical?.[0]?.town || ''}</Typography>
                                        <Typography>Country: {parsedPhysical?.[0]?.country || ''}</Typography>
                                        <Typography variant="subtitle1" sx={{ mt: 1 }}><strong>Postal Address:</strong></Typography>
                                        <Typography>Code: {parsedPostal?.[0]?.code || ''}</Typography>
                                        <Typography>City: {parsedPostal?.[0]?.city || ''}</Typography>
                                        <Typography>Town: {parsedPostal?.[0]?.town || ''}</Typography>
                                        <Typography>Country: {parsedPostal?.[0]?.country || ''}</Typography>
                                        <Typography variant="subtitle1" sx={{ mt: 1 }}><strong>Next of Kin:</strong></Typography>
                                        <Typography>Fullname: {parsedNok?.[0]?.fullname || ''}</Typography>
                                        <Typography>Email: {parsedNok?.[0]?.email || ''}</Typography>
                                        <Typography>Cell: {parsedNok?.[0]?.cell || ''}</Typography>
                                    </Grid>
                                </Grid>
                                <Box mt={2}>
                                    <Typography variant="h6">Role Explanation</Typography>
                                    <Typography>{selectedUser.role_explanation || 'N/A'}</Typography>
                                </Box>
                                <Box mt={2}>
                                    <Typography variant="h6">Drive Quote</Typography>
                                    <Typography>{selectedUser.drive_quote || 'N/A'}</Typography>
                                </Box>
                                <Box mt={2}>
                                    <Typography variant="h6">Passion</Typography>
                                    <Typography>{selectedUser.passion || 'N/A'}</Typography>
                                </Box>
                                <Box mt={2}>
                                    <Typography variant="h6">Knowledge</Typography>
                                    <Typography>{selectedUser.knowledge || 'N/A'}</Typography>
                                </Box>
                                <Box mt={2}>
                                    <Typography variant="h6">Core Values</Typography>
                                    <Typography>{selectedUser.core_values || 'N/A'}</Typography>
                                </Box>
                                <Box mt={2}>
                                    <Typography variant="h6">Focus</Typography>
                                    <Typography>{selectedUser.focus || 'N/A'}</Typography>
                                </Box>
                            </Box>
                        );
                    })()}
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setViewOpen(false)}>Close</Button>
                </DialogActions>
            </Dialog>
        </Box>
    );
};

export default Team;